/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RosterCardStyle = {
    PROFILE: 'PROFILE',
    ART: 'ART'
} as const;
export type RosterCardStyle = typeof RosterCardStyle[keyof typeof RosterCardStyle];


export function instanceOfRosterCardStyle(value: any): boolean {
    for (const key in RosterCardStyle) {
        if (Object.prototype.hasOwnProperty.call(RosterCardStyle, key)) {
            if (RosterCardStyle[key as keyof typeof RosterCardStyle] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RosterCardStyleFromJSON(json: any): RosterCardStyle {
    return RosterCardStyleFromJSONTyped(json, false);
}

export function RosterCardStyleFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosterCardStyle {
    return json as RosterCardStyle;
}

export function RosterCardStyleToJSON(value?: RosterCardStyle | null): any {
    return value as any;
}

export function RosterCardStyleToJSONTyped(value: any, ignoreDiscriminator: boolean): RosterCardStyle {
    return value as RosterCardStyle;
}

